
import './medias-area.scss'

import { faCheck, faImage, faTimes, faTrash, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { defineComponent, PropType } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { Media, MEDIA_DATA_CHANGED } from '@skinsoft/ui/src/item-card/media';
import { Touchable } from '@skinsoft/ui';

import {
    DELETE_IMAGE_CLICK_TOPIC,
    PRINCIPAL_IMAGE_CLICK_TOPIC, IMAGE_CLICK_TOPIC,
    IMAGE_UPLOADED_TOPIC,
    MEDIA_ID_CHANGED_FROM_CACHE,
    MEDIA_END_LOADING_TOPIC,
 } from '@skinsoft/bus/src/busTopics'


export interface DeleteImageClickEvent {
    imageListIndex: number,
    imageId?: string
}

export interface ImageClickEvent {
    id: string,
    imageListIndex: number,
}

export const MediaArea = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sMedia: Media,
        sTouchable: Touchable
    },
    props: {
        mediasIds: { type: Array as PropType<string[]>, required: true },
        id: {},
        canUpload: {},
        inProgress: {},
        shouldEmitOnBus: {
            type: Boolean,
            default: true,
        },
        shouldEmitEvent: {
            type: Boolean,
            default: true,
        },
        canDelete: {
            type: Boolean,
            default: true,
        },
        canSetFirstMedia: {
            type: Boolean,
            default: true,
        },
    },
    template: require("./medias-area.html"),
    data() {
        return {
            // Icons
            addImageIcon: faImage,
            deleteIcon: faTrash,
            checkIcon: faCheck,
            crossIcon: faTimes,
            anglesUp: faAngleUp,

            displayDeleteOverlayList: [] as boolean[],
            displayDefaultImageOverlayList: [] as boolean[],
            defaultImages: [] as (string | null)[],

            MEDIA_ID_CHANGED_FROM_CACHE,
            MEDIA_END_LOADING_TOPIC,
            MEDIA_DATA_CHANGED,
        }
    },
    methods: {
        onDefaultImage(index){
            this.displayDefaultImageOverlayList[index] = !this.displayDefaultImageOverlayList[index]
            this.$forceUpdate()
        },
        onDefaultImageClick(index) {
            this.$emit(PRINCIPAL_IMAGE_CLICK_TOPIC,  this.mediasIds[index])
            this.cancelDefaultImage(index)
        },
        cancelDefaultImage(index) {
            this.displayDefaultImageOverlayList[index] = false
            this.$forceUpdate()
        },
        onFileUploaded(event) {
            if(event?.target?.files?.length) {

            }
            for(const fileData of event.target.files) {
                const name = "REP-"+Date.now()+"."+ event.target.files[0].name.split('.').pop()
                const myNewFile = new File([fileData], name, {type: fileData.type})
                this.readFile(myNewFile)
            }
        },
        readFile(file: File) {
            const reader = new FileReader()

            const theRealThis = this

            reader.addEventListener("load", () => {
                // the event is emited by the component and on the bus for the following reason
                // on certain forms (EditReportScreen) there is 2 different components that features medias and using bus
                // to listen to the image upload would cause the media to be added by both. On the other end emiting on bus
                // is usefull when some components have to react to media loading (validation button of forms)
                if(theRealThis.shouldEmitEvent) {
                    this.$emit(IMAGE_UPLOADED_TOPIC, { url: reader.result, file: file })
                }
                if(theRealThis.shouldEmitOnBus) {
                    this.emitOnBus(IMAGE_UPLOADED_TOPIC, { url: reader.result, file: file })
                }
            }, false)
            reader.readAsDataURL(file)
        },
        onImageClick(imageId, index) {
            this.$emit(IMAGE_CLICK_TOPIC, { id: imageId, imageListIndex: index })
        },
        onTrashClick(index) {
            this.displayDeleteOverlayList[index] = !this.displayDeleteOverlayList[index]
            this.$forceUpdate()
        },
        onDeleteImageClick(index) {
            const imageId = this.mediasIds[index]
            this.displayDeleteOverlayList.splice(index, 1)
            this.$emit(DELETE_IMAGE_CLICK_TOPIC, { imageListIndex: index, imageId: imageId } as DeleteImageClickEvent)
        },
        onMediaDataChanged(mediaData: string, index: number) {
            this.defaultImages[index] = mediaData
        },
        cancelDelete(index) {
            this.displayDeleteOverlayList[index] = false
            this.$forceUpdate()
        },
    },
    watch: {
        mediasIds() {
            this.displayDeleteOverlayList.push(false);
            this.displayDefaultImageOverlayList.push(false);
        },
    },
})
